/**
 * Main Collection Section Logic (filter and sorting)
 * ------------------------------------------------------------------------
 * @summary ajax-based js logic on top of filter-sort form. Filtering and 
 * sorting works natively without any js which means it's all handled server
 * side, js just makes it dynamic. 
 * 
 * How works: everytime an input is changed inside the filter-sort forms,
 * an event is fired ('filter:changed'), <main-collection> listens for that
 * event and then fetches the new section from the server. CollectionGrid then
 * refreshes it's own UI and fires back an event to <filter-sort> with the new
 * html so that <filter-sort> can take care re-rendering it's own UI elements.
 */

class CollectionGrid extends HTMLElement {
    constructor() {
      super();
  
      this._selectors = {
        productGrid: '[js-products-grid]',
        nextPage: '[js-collection-next-page]',
        nextPageLink: '[js-collection-next-pag-link]',
        mobileCollectionHeader: '[js-mobile-collection-header]',
        mobileCollectionNavTrigger: '[js-mobile-collection-nav-trigger]',
        nextPageItems: '[js-infinite-item]'
      }
  
      this._refresh = [
        '[js-products-grid]',
        '[js-collection-pagination]'
      ]

      // cache fetches for performance
      this._cache = []
    }
  
    connectedCallback() {
      this._productGrid = this.querySelector(this._selectors.productGrid);
      this._nextPageBtn = this.querySelector(this._selectors.nextPage);
      this._mobileCollectionHeader = this.querySelector(this._selectors.mobileCollectionHeader);
      this._setListeners();
      this._retainPosition();
      this._handleStickyMobileCollectionHeader();
      this._mobileCollectionNavDrawer();

      if (this.querySelector(this._selectors.nextPageLink) && this.dataset.infiniteScrollEnabled == 'true') {
        this._initInfiniteScroll();
      }
    }
  
    _setListeners() {
      document.addEventListener('filter:change', this._handleFilterChange);
    }
  
    _mobileCollectionNavDrawer = () => {
      if (!this._mobileCollectionHeader) {
        return;
      }
  
      const mobileCollectionNavTrigger = this._mobileCollectionHeader.querySelector(this._selectors.mobileCollectionNavTrigger);
      mobileCollectionNavTrigger.addEventListener('click', () => {
        if (this._mobileCollectionHeader.dataset.showNav == 'true') {
          this._mobileCollectionHeader.dataset.showNav = 'false';
        } else {
          this._mobileCollectionHeader.dataset.showNav = 'true';
        }
      });
    }
  
    _handleStickyMobileCollectionHeader = () => {    
      if (!this._mobileCollectionHeader) {
        return;
      }
  
      const main = document.getElementById('MainContent');
      document.addEventListener('scroll', (evt) => {
        if (window.innerWidth < 1025) {
          if (main.getBoundingClientRect().top < 0) {
            this._mobileCollectionHeader.dataset.showNav = 'false';
          } else {
            this._mobileCollectionHeader.dataset.showNav = 'true';
          }
        }
      });
    }
  
    _handleFilterChange = (evt) => {
      if (this.querySelector(this._selectors.nextPageLink) && this.dataset.infiniteScrollEnabled == 'true') {
        this._checkInfiniteScroll(evt.detail.html);
      }
    }
  
    _retainPosition = () => {
      if (history.state && history.state.products) {
        this._productGrid.innerHTML = history.state.products;
      }
    }
  
    _initInfiniteScroll = () => {
      this.infScroll = new InfiniteScroll(this._selectors.productGrid, {
        // options
        path: this._selectors.nextPageLink,
        append: this._selectors.nextPageItems,
        history: false,
        historyTitle: false,
        loadOnScroll: true,
        button: this._selectors.nextPageLink
      });
    }

    _checkInfiniteScroll = (html) => {
      html = new DOMParser().parseFromString(html, 'text/html').querySelector('.main-collection-container');
      let productGrid = html.querySelector(this._selectors.productGrid);
      let infScrollData = InfiniteScroll.data(productGrid);

      if (infScrollData) {
        infScrollData.destroy();
      } else {
        this._initInfiniteScroll();
      }
    }
  }

  customElements.define("s-collection-grid", CollectionGrid);